import { BotaoIcone, Esqueleto } from '@persona/ui';
import * as RDialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { Suspense, type ReactNode } from 'react';

/** Marca da janela do registro: os atalhos da página (Esc, F4) seguem valendo dentro dela. */
export const SELETOR_OUTRO_DIALOGO = '[role="dialog"]:not(.janela-registro), [role="alertdialog"]';

/**
 * Fechar a janela é o mesmo que o Esc da página: o detalhe volta para a lista e o formulário pergunta antes de descartar.
 * Por isso o pedido vira um Esc novo no window, onde o despachante de atalhos escolhe quem trata.
 */
function pedirFechar() {
  window.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true, cancelable: true }));
}

/** Ver, alterar, incluir e copiar um registro numa janela sobre a lista da rotina (a lista continua visível atrás). */
export function JanelaRegistro({ titulo, children }: { titulo: string; children: ReactNode }) {
  return (
    <RDialog.Root open onOpenChange={(aberto) => !aberto && pedirFechar()}>
      <RDialog.Portal>
        <RDialog.Overlay className="sobreposicao" />
        <RDialog.Content
          className="janela-registro folha"
          aria-describedby={undefined}
          onEscapeKeyDown={(e) => {
            e.preventDefault();
            pedirFechar();
          }}
          onPointerDownOutside={(e) => {
            // Menus e calendários abertos dentro do formulário vivem num portal fora da janela: clicar neles não fecha.
            const alvo = e.target as HTMLElement | null;
            e.preventDefault();
            if (!alvo?.closest('[data-radix-popper-content-wrapper], [role="listbox"], [role="menu"]')) pedirFechar();
          }}
        >
          <RDialog.Title className="sr-only">{titulo}</RDialog.Title>
          <BotaoIcone className="janela-registro-fechar" rotulo="Fechar (Esc)" icone={<X size={18} strokeWidth={1.75} />} onClick={pedirFechar} />
          <div className="janela-registro-corpo">
            <Suspense fallback={<Esqueleto forma="campo" linhas={6} />}>{children}</Suspense>
          </div>
        </RDialog.Content>
      </RDialog.Portal>
    </RDialog.Root>
  );
}
